import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import axios from "axios";
import qs from "qs";
import isEmpty from "lodash/isEmpty";
import update from "immutability-helper";

// Components
import Loader from "../../../utils/Loader";
import TTSearch from './products-search/TTSearch';

// State
import { updateTopTierProduct } from '../../../../store/actions/topTier';
import { userTokenUpdate, userLogout } from "../../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../../shared/vars";

class AdminTopTierProductsEdit extends Component{

    constructor(props){
        super(props)
        this.state = {
            errors: {},
            updateProductLoading: false,
            productsLoading: false,
            products: [],
            q: '',
            queryProducts: '',
            queryAssigned: '',

            // Top Tier Products
            topTierProducts: [],
            topTierProductsLoading: false,

            // Table Sort
            activeSortedColumn: '',
            sortColumnsAdd: {
                title: 'DESC',
                sku: 'DESC'
            },
        }
    }

    componentDidMount(){
        this.loadTopTierProducts(this.props.topTier.id);
        this.productSearch('');
    }

    loadTopTierProducts(top_tier_id){
        const { user } = this.props;

        this.setState({
            topTierProductsLoading: true,
        }, () => {
            const token = user.token;
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

            return axios.get(REACT_APP_API_URL + "top-tier-products/" + top_tier_id, { headers: AUTH_HEADER })
            .then(response => {
                if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                    this.props.userLogout("admin");
                } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                    this.setState({ topTierProductsLoading: false, error: response.data.message });
                } else {
                    this.setState({
                        topTierProductsLoading: false,
                        topTierProducts: response.data.top_tier_products
                    });
                }
            })
            .catch(err => {
                if (err.response) {
                    this.setState({ topTierProductsLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                } else {
                    this.setState({ topTierProductsLoading: false, error: err.message });
                }
            });
        });
    }

    productSearch = (q, column = '', sortOrder = null) => {
        const { user } = this.props;

        // Put querystring data together
		const data = qs.stringify(
			{
                q,
                top_tier_id: !!this.props.topTier.id ? this.props.topTier.id : 0,
                column: column,
                order: isEmpty(sortOrder) ? '' : sortOrder
			},
			{ arrayFormat: ["brackets"] }
		);
    
        this.setState({
            productsLoading: true,
            q: q
        }, () => {
            const token = user.token;
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
            return axios
                .get(REACT_APP_API_URL + "top-tier-products/all-products?" + data, { headers: AUTH_HEADER })
                .then(response => {
                    if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                        this.props.userLogout("admin");
                    } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                        this.setState({ productsLoading: false, error: response.data.message });
                    } else {
                        // this.loadTopTierProducts(this.props.topTier.id);
                        this.setState({
                            productsLoading: false,
                            products: response.data.products
                        });
                    }
                })
                .catch(err => {
                    if (err.response) {
                        this.setState({ productsLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                    } else {
                        this.setState({ productsLoading: false, error: err.message });
                    }
                });
        })
    }

    updateTopTierProduct(type, id){
        const { user } = this.props;

        this.setState({
            updateProductLoading: true
        }, () => {
            const token = user.token;
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

            const params = {
                id: this.props.topTier.id,
                update_type: type,
                product_id: id
            }

		    return axios.post(REACT_APP_API_URL + 'top-tier-products/', params, { headers: AUTH_HEADER })
                .then(response => {
                    if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                        this.props.userLogout("admin");
                    } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                        this.setState({ updateProductLoading: false, error: response.data.message });
                    } else {
                        // this.loadTopTierProducts(this.props.topTier.id);
                        this.setState({
                            updateProductLoading: false
                        } , () => {
                            this.loadTopTierProducts(this.props.topTier.id);
                            this.productSearch(this.state.q);
                        });
                    }
                })
                .catch(err => {
                    if (err.response) {
                        this.setState({ updateProductLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                    } else {
                        this.setState({ updateProductLoading: false, error: err.message });
                    }
                });
        })
    }

    // updateProduct(type, id){
    //     // Update Products (add or remove)
    //     this.props.updateTopTierProduct({
    //         id: this.props.topTier.id,
    //         update_type: type,
    //         product_id: id
    //     });

    //     // Reload top tier to show new updates
    //     this.setState({
    //         productsLoading: true,
    //         topTierProductsLoading: true
    //     }, () => {
    //         this.loadTopTierProducts(this.props.topTier.id);
    //         this.productSearch(this.state.q);
    //     })
    // }

    sort = (column) => {
        const {sortColumnsAdd} = this.state;

        this.setState({ activeSortedColumn: column }, 
        () => {
            this.setState({
                sortColumnsAdd: update(sortColumnsAdd, {
                    [column]: { $set: sortColumnsAdd[column] === 'DESC' ? 'ASC' : 'DESC' }
                })
            }, () => { this.productSearch(this.state.q, column, sortColumnsAdd[column]) })
        })
    }

    render(){
        const {success} = this.props;
        const {productsLoading, topTierProducts, topTierProductsLoading, errors, products, updateProductLoading} = this.state;

        return (
            updateProductLoading || productsLoading || topTierProductsLoading ? 
            <div className="pt2 pb2">
                <Loader />
            </div> :
            <Fragment>                
                {/* Products Forms */}
                <div className="tt-prod">
                    <div className="tt-prod-col">
                        <h2>Product List</h2>
                        <TTSearch 
                            data={products}
                            itemsPerPage={10}
                            type={'add'}
                            notification={'No results. Type into the searchbar to query all products.'}
                            searchQuery={this.state.queryProducts}
                            storeSearch={(q) => this.setState({queryProducts: q})}
                            action={(type, prod_id) => this.updateTopTierProduct(type, prod_id)}
                            sortData={this.state.sortColumnsAdd}
                            activeSortedColumn={this.state.activeSortedColumn}
                            sort={(column) => this.sort(column)}
                        />
                    </div>
                    <div className="tt-prod-col">
                        <h2>Discounted Products</h2>
                        <TTSearch 
                            data={!!topTierProducts ? topTierProducts : []}
                            itemsPerPage={10}
                            type={'remove'}
                            notification={'There are currently no products assigned to this top tier.'}
                            searchQuery={this.state.queryAssigned}
                            storeSearch={(q) => this.setState({queryAssigned: q})}
                            action={(type, prod_id) => this.updateTopTierProduct(type, prod_id)}
                            sortData={this.state.sortColumnsAdd}
                            activeSortedColumn={this.state.activeSortedColumn}
                            sort={(column) => this.sort(column)}
                        />
                    </div>
                </div>
                <div className="tt-prod-success">
                    {!!errors && errors.length > 0 && <div className="error msg_animate">{errors.general}</div>}
                    {!!success && success.length > 0 && <div className="success msg_animate">{success}</div>}
                </div>
            </Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        updateProductLoading: state.topTier.updateProductLoading,
        success: state.topTier.success
    }
}

export default connect(mapStateToProps, { updateTopTierProduct, userTokenUpdate, userLogout})(AdminTopTierProductsEdit)


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/products/AdminTopTierProductsEdit.js